import { api } from "@/api";

import { Sport } from "@/types/ApiResponses/Sport";

export async function addFavoriteSport(sport: Sport) {
  const res = await api.client.post("/sports-new/favorite", {
    sportId: sport.id,
  });
  return res.data;
}
